const winterWhite = {
    id: "winter-white",
    name: "Winter White",
    ornament: "linear",
    radius: "sharp",
    fonts: {
        display: "Newsreader",
        heading: "Outfit",
        body: "Outfit",
    },
    colors: {
        bg: "#f4f7f8",
        bgAlt: "#e7eef1",
        surface: "rgba(255,255,255,0.92)",
        primary: "#24343c",
        primaryHover: "#16222a",
        accent: "#b7c4ce",
        accentSoft: "#dce4ea",
        rose: "#d5dee4",
        roseDeep: "#8a9eaa",
        leaf: "#8aa0a8",
        text: "#1c282e",
        textMuted: "#5a6e78",
        border: "#c5d3da",
        buttonText: "#f4f7f8",
    },
};

const sunsetTerrace = {
    id: "sunset-terrace",
    name: "Sunset Terrace",
    ornament: "floral",
    radius: "round",
    fonts: {
        display: "Great Vibes",
        heading: "Fraunces",
        body: "Newsreader",
    },
    colors: {
        bg: "#fff1e8",
        bgAlt: "#fbe4d6",
        surface: "rgba(255,250,246,0.92)",
        primary: "#b64b3a",
        primaryHover: "#943a2c",
        accent: "#e7a04a",
        accentSoft: "#f5d296",
        rose: "#f0b59a",
        roseDeep: "#c4785c",
        leaf: "#c47b62",
        text: "#3f241c",
        textMuted: "#8a6256",
        border: "#efd0c2",
        buttonText: "#fff7f3",
    },
};

const forestChapel = {
    id: "forest-chapel",
    name: "Forest Chapel",
    ornament: "floral",
    radius: "soft",
    fonts: {
        display: "Cormorant Garamond",
        heading: "EB Garamond",
        body: "Newsreader",
    },
    colors: {
        bg: "#14211b",
        bgAlt: "#1c2e25",
        surface: "rgba(28,42,34,0.92)",
        primary: "#f0e2c8",
        primaryHover: "#fff6e6",
        accent: "#d9a441",
        accentSoft: "#ecd096",
        rose: "#c9a394",
        roseDeep: "#a68474",
        leaf: "#8ea57a",
        text: "#f3eee4",
        textMuted: "#c9d2c4",
        border: "#3e5648",
        buttonText: "#14211b",
    },
};

const porcelainBlue = {
    id: "porcelain-blue",
    name: "Porcelain Blue",
    ornament: "linear",
    radius: "sharp",
    fonts: {
        display: "EB Garamond",
        heading: "Libre Baskerville",
        body: "Libre Baskerville",
    },
    colors: {
        bg: "#fbfcfe",
        bgAlt: "#f0f4fa",
        surface: "#ffffff",
        primary: "#1e3a6e",
        primaryHover: "#152c54",
        accent: "#1e3a6e",
        accentSoft: "#d6e0f0",
        rose: "#d6e0f0",
        roseDeep: "#90a9d5",
        leaf: "#1e3a6e",
        text: "#1e3a6e",
        textMuted: "#5c6e90",
        border: "#1e3a6e",
        buttonText: "#fbfcfe",
    },
};

const seasons = [winterWhite, sunsetTerrace, forestChapel, porcelainBlue];

export default seasons;
